import { TransformControls } from 'three/addons/controls/TransformControls.js';
import { Camera, Object3D } from 'three';
import { TransformToolEnum } from '@modules/three/common/transformMesh/TransformToolEnum';
import { threeInteractionStore } from '@modules/three/store/threeInteractionStore';
import { threeStore } from '../../store/threeStore';

export default class Gizmo extends TransformControls {
  private parentObject: Object3D | null = null;
  private objectChangeCallback: () => void = () => {};

  constructor(camera: Camera, domElement: HTMLElement) {
    super(camera, domElement);
    this.space = 'local';

    threeInteractionStore.subscribe((state) => {
      this.changeMode(state.transformTool);
    });

    this.addEventListener('dragging-changed', (event: any) => {
      const controls = threeStore.getState().rootState?.controls;
      if (controls) {
        controls.enabled = !event.value;
        controls.enablePan = !event.value;
        controls.enableZoom = !event.value;
        controls.enableRotate = !event.value;
      }
    });
  }

  public attachToParent(parent: Object3D, objectChangeCallback: () => void) {
    this.detachParent();
    this.parentObject = parent;
    this.attach(this.parentObject);
    this.objectChangeCallback = objectChangeCallback;
    this.addEventListener('objectChange', this.objectChangeCallback);
  }

  public detachParent() {
    this.detach();
    this.removeEventListener('objectChange', this.objectChangeCallback);
    this.objectChangeCallback = () => {};
  }

  public changeMode(mode?: TransformToolEnum | null) {
    if (!mode) {
      return;
    }
    this.setMode(mode);
  }
}
